import request from './index'
//获取图形验证码
export function getLoginRegister(params) {
  return request({
    url: '/api/Code/GetLoginRegister',
    method: 'get',
    params
  })
}
//发送短信验证码
export function sendMobileCode(data) {
  return request({
    url: '/api/MemberAccount/SendMobileCode',
    method: 'post',
    data
  })
}
//注册
export function register(data) {
  return request({
    url: '/api/MemberAccount/Register',
    method: 'post',
    data
  })
}
//登录
export function login(data) {
  return request({
    url: '/api/MemberAccount/Login',
    method: 'post',
    data
  })
}
//获取会员信息
export function getmemberInfo(token,data) {
  return request({
    url: '/api/MemberAccount/GetmemberInfo',
    method: 'post',
    headers: {'Token': token},
    data
  })
}
//修改会员信息
export function editmemberInfo(data) {
  return request({
    url: '/api/MemberAccount/EditmemberInfo',
    method: 'post',
    data
  })
}
//注销
export function logOut(token) {
  return request({
    url: '/api/MemberAccount/LogOut',
    method: 'get',
    headers: {'Token': token},
  })
}
//修改密码
export function changePwd(token,data) {
  return request({
    url: '/api/MemberAccount/ChangePwd',
    method: 'post',
    headers: {'Token': token},
    data
  })
}
//输入原密码重置密码
export function resetPwd(token,data) {
  return request({
    url: '/api/MemberAccount/ResetPwd',
    method: 'post',
    headers: {'Token': token},
    data
  })
}